var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"as-a-master-page-menu"},[_c('EmployeeHorizontalMenu',{attrs:{"menuItems":_vm.computedMenuItems,"initialTab":_vm.initialTab},on:{"tab-selected":_vm.handleTabSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }